import React from 'react'

import { withTheme } from 'modules/util'
import ProgressBar from '../ProgressBar'

import loadingTheme from './theme.scss'

export function Loading({ theme, active = true }) {
  if (!active) return null

  return (
    <div className={theme.loading}>
      <ProgressBar />
    </div>
  )
}

export default withTheme(loadingTheme, Loading)



// WEBPACK FOOTER //
// ./client/modules/ui/components/Loading/index.js